export default __webpack_public_path__ + "static/media/antp_ingvehicular_JulioOlivares_Movil.4c1825b9.jpg";